"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * SPDX-FileCopyrightText: © 2019 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
var ClayDatePickerWeekday = function ClayDatePickerWeekday(_ref) {
  var weekday = _ref.weekday;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "date-picker-col"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "date-picker-calendar-item date-picker-day"
  }, /*#__PURE__*/_react.default.createElement("abbr", null, weekday)));
};

var _default = ClayDatePickerWeekday;
exports.default = _default;